import AppRoutes from '@/routes';
import GlobalSnackbar from '@/components/GlobalSnackbar';

function App() {
  return (
    <>
      <AppRoutes />
      <GlobalSnackbar />
    </>
  );
}

export default App;
